// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uq_oY","method":"styles_method__e_FVs","label":"styles_label__DK6kD","radioLabel":"styles_radioLabel__LApjP"};